var exports = {
  "kL": "AddFriendSheet.module__container___a0hmbV",
  "XG": "AddFriendSheet.module__scroller___a0hmbV",
  "Qs": "AddFriendSheet.module__content___a0hmbV",
  "Y4": "AddFriendSheet.module__requestsSection___a0hmbV",
  "Ic": "AddFriendSheet.module__requestsGroup___a0hmbV",
  "sg": "AddFriendSheet.module__requestsHeader___a0hmbV",
  "vA": "AddFriendSheet.module__requestsList___a0hmbV",
  "Jt": "AddFriendSheet.module__requestDivider___a0hmbV",
};

module.exports = exports;
